module.exports = __webpack_public_path__ + "static/img/source3.2332489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/equipment/zh/source3.png
// module id = hi/k
// module chunks = 1